import { Component, Suspense } from "react";
import api from "../../services/api";
import TokenService from "../../services/token.service";
import { withRouter } from '../../common/with-router';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Cookies from 'js-cookie';
import GlobalContext from "../../contexts/GlobalContext";
import { Spinner } from "react-bootstrap";

import LoginDefault from "./LoginDefault";
import { getCustomLoginComponent } from "./LoginRegistry";
import { getConfig } from "../../common/config";

class Login extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.handleLogin = this.handleLogin.bind(this);
        this.onChangeUsername = this.onChangeUsername.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeQrcode = this.onChangeQrcode.bind(this);
        this.toggleForgotPassword = this.toggleForgotPassword.bind(this);
        this.handlePasswordReset = this.handlePasswordReset.bind(this);

        this.state = {
            username: "",
            password: "",
            qrcode: "",
            segundo_fator: false,
            loading: false,
            loading_ambiente: true,
            token: "",
            secret: '',
            programa_dados: [],
            showForgotPassword: false,
            emailForReset: "",
            cnpjForReset: "",
            tipo_pessoa: "fisica",
            accessType: "default",
            showPassword: false,
            pParam: null,
            forgotFromLanding: false,
        };
    }

    componentDidMount() {
        const searchParams = new URLSearchParams(window.location.search);
        const programaId = searchParams.get("p");
        const forgotPassword = searchParams.get("forgot_password");
        const accessType = searchParams.get("access_type") || "default";

        this.setState({
            accessType,
            showForgotPassword: forgotPassword === "1",
            // Quando o fluxo de redefinição é aberto direto pela URL (landing externa),
            // não há tela de login do HNS para "cancelar" de volta — esconde o botão
            // Cancelar para o usuário não cair na tela de login do HNS. (temporário)
            forgotFromLanding: forgotPassword === "1",
            tipo_pessoa: "fisica",
        });

        if (programaId) {
            this.setState({ pParam: programaId });
            this.carregaDadosPrograma(programaId);
        } else {
            this.setState({ loading_ambiente: false });
        }
    }

    carregaDadosPrograma = (programa_uuid) => {
        const config = {
            headers: {
                'X-USERNAME': import.meta.env.VITE_X_USERNAME,
            }
        };

        api.get(`/programas/publico/${programa_uuid}/`, config)
            .then(response => {
                this.setState({
                    programa_dados: response.data,
                    loading_ambiente: false,
                });
            })
            .catch(error => {
                console.error('Erro ao carregar dados do programa atual:', error);
                this.setState({ loading_ambiente: false });
            });
    };

    onChangeUsername(e) {
        this.setState({
            username: e.target.value.toLowerCase()
        });
    }

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    onChangeQrcode(e) {
        this.setState({
            qrcode: e.target.value
        });
    }

    handleLogin(e) {
        e.preventDefault();

        this.setState({
            loading: true
        });

        localStorage.removeItem('globalContextValue');

        const payload = {
            username: this.state.username,
            password: this.state.password,
        };

        if (this.state.segundo_fator) {
            payload.qrcode = this.state.token;
        }

        if (this.state.pParam) {
            payload.programa_uuid = this.state.pParam;
        }

        api({
            method: 'POST',
            url: '/login/',
            data: payload
        })
            .then(response => {
                this.setState({ loading: false });

                if (!response.data.access) {
                    this.setState({ segundo_fator: true });

                    if (response.data.qrcode) {
                        this.setState({
                            qrcode: response.data.qrcode.qr,
                            secret: response.data.qrcode.secret,
                        });
                    }
                    return;
                }

                const response_api = response.data;
                const restricoes = response_api.restricoes || [];
                let queryParam = '';

                if (restricoes.length > 1) {
                    queryParam = '?definir_acesso=1';
                }

                if (restricoes.length > 0 && restricoes[0].trocar_senha) {
                    localStorage.setItem('trocar_senha', 1);
                }

                if (this.state.pParam) {
                    Cookies.set('p_login', this.state.pParam, { secure: true, sameSite: 'Strict', path: '/' });
                }

                TokenService.setUser(response_api);
                const { access, refresh, ...userWithoutTokens } = response_api;

                this.context.setGlobalValue({
                    user: userWithoutTokens,
                    programaId: this.state.pParam || null,
                    timestamp: new Date().getTime()
                });

                this.props.router.navigate('/' + queryParam);
                window.location.reload();
            })
            .catch(error => {
                this.setState({ loading: false });

                let msg = 'Erro ao realizar o login, tente novamente.';
                if (error.response && error.response.data) {
                    const data = error.response.data;
                    if (data.non_field_errors) {
                        msg = data.non_field_errors.join(' ');
                    } else if (data.response) {
                        msg = data.response;
                    } else {
                        msg = JSON.stringify(data);
                    }
                }

                withReactContent(Swal).fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    html: `<p>Não foi possível realizar o login.</p><p class="mt-4">${msg}</p>`
                });
            });
    }

    toggleForgotPassword() {
        this.setState(prevState => ({
            showForgotPassword: !prevState.showForgotPassword
        }));
    }

    handlePasswordReset(e) {
        const MySwal = withReactContent(Swal);
        const programaId = this.state.pParam;

        e.preventDefault();

        this.setState({ loading: true });

        const payload = {
            email: this.state.emailForReset,
            cnpj: this.state.cnpjForReset,
        };

        let url_api = '';
        if (programaId) {
            payload.p = programaId;
            payload.programa_uuid = programaId;
            url_api = `/password_reset/custom/?p=${programaId}`;
        } else {
            url_api = '/password_reset/';
        }

        api({
            method: 'POST',
            url: url_api,
            data: payload
        })
            .then(() => {
                this.setState({ loading: false });

                MySwal.fire({
                    title: 'Sucesso',
                    icon: 'success',
                    html: 'Verifique sua caixa de email e siga as instruções enviadas',
                    showCloseButton: true,
                }).then(() => {
                    // Se o programa tem uma landing page configurada, volta pra ela apos o pedido de reset.
                    const landingUrl = getConfig(this.state.programa_dados?.configuracoes, 'Landing_Page.url', '');
                    if (landingUrl) {
                        window.location.href = landingUrl;
                        return;
                    }
                    if (programaId) {
                        const extraQuery = this.state.accessType === 'beneficiario' ? '&access_type=beneficiario' : '';
                        this.props.router.navigate(`/login/?p=${programaId}${extraQuery}`);
                        window.location.href = `/login/?p=${programaId}${extraQuery}`;
                    } else {
                        this.props.router.navigate('/login/');
                        window.location.reload();
                    }
                });
            })
            .catch(error => {
                let msg_erro = <p>Não foi possível solicitar a redefinição de senha, verifique se seu email está correto</p>;

                if (error.response && error.response.status === 429) {
                    const retryAfter = parseInt(error.response.headers?.['retry-after'], 10);
                    const espera = Number.isFinite(retryAfter) && retryAfter > 0
                        ? ` Aguarde ${retryAfter} segundo(s) e tente novamente.`
                        : ' Aguarde alguns minutos e tente novamente.';
                    msg_erro = <p>Muitas solicitações de redefinição de senha em um curto período.{espera}</p>;
                } else if (error.response && error.response.data && 'password' in error.response.data) {
                    msg_erro = <p>{error.response.data.password}</p>;
                }

                MySwal.fire({
                    icon: 'warning',
                    showCloseButton: true,
                    html: msg_erro,
                });

                this.setState({ loading: false });
            });
    }

    toggleShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    setToken = (val) => this.setState({ token: val });
    setTipoPessoa = (val) => this.setState({ tipo_pessoa: val });
    setEmailForReset = (val) => this.setState({ emailForReset: val });
    setCnpjForReset = (val) => this.setState({ cnpjForReset: val });

    render() {
        const pParam = this.state.pParam;
        const hasBothParams = pParam;

        const handlers = {
            handleLogin: this.handleLogin,
            onChangeUsername: this.onChangeUsername,
            onChangePassword: this.onChangePassword,
            onChangeQrcode: this.onChangeQrcode,
            toggleForgotPassword: this.toggleForgotPassword,
            handlePasswordReset: this.handlePasswordReset,
            toggleShowPassword: this.toggleShowPassword,
            setToken: this.setToken,
            setTipoPessoa: this.setTipoPessoa,
            setEmailForReset: this.setEmailForReset,
            setCnpjForReset: this.setCnpjForReset,
        };

        const CustomView = getCustomLoginComponent(pParam);

        if (CustomView) {
            return (
                <Suspense fallback={<div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>}>
                    <CustomView
                        {...this.state}
                        handlers={handlers}
                        pParam={pParam}
                        hasBothParams={hasBothParams}
                        accessType={this.state.accessType}
                    />
                </Suspense>
            );
        }

        return (
            <LoginDefault
                {...this.state}
                handlers={handlers}
                pParam={pParam}
                hasBothParams={hasBothParams}
                accessType={this.state.accessType}
            />
        );
    }
}

export default withRouter(Login);
